<template>
  <div class="containar">
    <div style="float: left;width: 100%;height: 20%">
      <div id="logoDiv">
        <img src="../../../static/img/logo.png" id="logo">
      </div>
      <div id="logotextDiv">
        <span style="font-size: 20px">甘肃智通科技工程检测咨询有限公司</span><br>
        <span style="font-size: 20px">Gansu ZhiTong Technology Enginnering Detection Consulting Co.,LTD</span><br>
        <span style="font-weight:bold;font-size: 30px">公路工程试验检测资产管理系统</span><br>
        <span style="font-weight:bold;font-size: 10px">MANAGEMENT SYSTEM OF HIGHWAY ENGINEERING TEST AND DETECTION
          EQUIPMENT2.0</span><br>
      </div>
    </div>
    <div id="logoimgDiv">
      <img src="../../../static/img/bg2.png" style="height: 100%;width: 100%">
    </div>
    <div id="loginFormDiv">
      <p style="text-align: left;margin-left: 15px;height: 50px;line-height: 50px;font-size: 20px">修改初始密码</p>
      <div style="padding: 0 15px;">
        <p style="color:#E6A23C;font-size:13px;margin-bottom:15px;">您的密码为初始密码，为保证账号安全，请修改密码</p>
        <el-input v-model="form.password" placeholder="请输入新密码" type="password" show-password
          style="margin-bottom:12px;">
        </el-input>
        <el-input v-model="form.confirmPwd" placeholder="请再次输入新密码" type="password" show-password
          style="margin-bottom:16px;">
        </el-input>
        <el-button type="primary" style="width:100%;" @click="handleSubmit" :loading="loading">确认修改</el-button>
      </div>
    </div>
    <FooterBar />
  </div>
</template>

<script>
import { forceChangePwd } from '../../api/api'
import FooterBar from '../../components/FooterBar'
export default {
  name: "ForceChangePwd",
  components: { FooterBar },
  data() {
    return {
      loading: false,
      form: {
        password: '',
        confirmPwd: ''
      }
    }
  },
  methods: {
    handleSubmit() {
      if (!this.form.password) {
        this.$message({ message: '请输入新密码', type: 'warning' })
        return
      }
      if (this.form.password !== this.form.confirmPwd) {
        this.$message({ message: '两次输入的密码不一致', type: 'warning' })
        return
      }
      this.loading = true
      forceChangePwd({ password: this.form.password }).then(res => {
        if (res.status == 200) {
          this.$message({ message: '密码修改成功', type: 'success' })
          setTimeout(() => {
            this.$router.push({ path: "/DeviceInfo", name: "设备信息", title: "设备信息" })
          }, 1000)
        } else {
          this.$message({ message: res.message || '修改失败', type: 'error' })
          this.loading = false
        }
      }).catch(() => {
        this.$message({ message: '请求失败，请重试', type: 'error' })
        this.loading = false
      })
    }
  }
}
</script>

<style scoped>
body { margin: 0px; padding: 0px; font-size: 14px; -webkit-font-smoothing: antialiased; }
.containar { top: 0px; left: 0px; height: 100vh; width: 100vw; background-color: #255F9E }
#logoDiv { width: 90px; height: 90px; margin-left: 15px; }
#logo { width: 100%; height: 100%; }
#logotextDiv { position: absolute; left: 120px; top: 1%; width: 700px; height: 10%; text-align: left; color: white; }
#logoimgDiv { width: 40%; height: 73%; }
#loginFormDiv { position: relative; left: 65%; bottom: 50%; background-color: white; border-radius: 5%; height: 38%; width: 350px; }
.containar >>> .el-input__inner { height: 40px; }
</style>



// WEBPACK FOOTER //
// src/views/users/ForceChangePwd.vue